import { yupResolver } from "@hookform/resolvers/yup";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import {
  defaultSetAddress,
  deleteMemberAddress,
  fetchListMemberAddress,
  insertMemberAddress,
} from "../../../api/memberAddress";
import { failAlert, successAlert } from "../../../common/alert";
import { AddressSchema } from "../../../common/util/addressYup";
import * as Addr from "./MyAddress-styles";
import NewMyAddress from "./new/MyAddress-new";
import { isLoaded } from "../../../redux/action/loading";

const MyAddress = ({ isLoaded, loading, ownProps }) => {
  const router = useRouter();
  // api 통신 데이터
  const [myAddress, setMyAddress] = useState();
  const [myAddressCount, setMyAddressCount] = useState(0);
  // 등록 & 수정 관련
  const [isOpen, setIsOpen] = useState(false);
  const [mapInputs, setMapInputs] = useState({
    addressGps: {
      mapx: "",
      mapy: "",
    },
  });
  const [isEdit, setIsEdit] = useState(false);
  const [editAddress, setEditAddress] = useState();
  // api
  const fetchAddressList = async () => {
    const res = await fetchListMemberAddress();
    setMyAddressCount(res.Data?.Count);
    setMyAddress(res.Data?.Rows);
    isLoaded();
  };

  const deleteAddress = async (acode) => {
    const body = {
      modes: "DeleteSet",
      acode: acode,
    };
    const res = await deleteMemberAddress(body);
    if (res?.code === "0000") {
      successAlert("삭제 되었습니다.");
      fetchAddressList();
    } else {
      failAlert(res?.data?.Msg);
    }
  };

  // 기본 배송지 등록
  const selectDefault = async (acode) => {
    const body = {
      modes: "DefaultSet",
      acode: acode,
    };
    const res = await defaultSetAddress(body);
    if (res.code === "0000") {
      successAlert("설정되었습니다.");
      fetchAddressList();
    } else {
      failAlert(res.data.Msg);
    }
  };

  // 수정하기
  const handleIsEdit = (el) => {
    setIsEdit(true);
    setIsOpen(true);
    setEditAddress(el);
  };

  useEffect(() => {
    fetchAddressList();
  }, []);

  return (
    <>
      {loading === false &&
        (!isOpen ? (
          <Addr.Container>
            <Addr.Header>
              <h6>총 {myAddressCount} 개</h6>
              <div className="add-address-btn" onClick={() => setIsOpen(true)}>
                <i className="fi-rs-plus" />
                <span className="pl-10 font-md">배송지 등록</span>
              </div>
            </Addr.Header>
            <Addr.ContentWrapper>
              {myAddress?.map((el, i) => (
                <Addr.AddressBox key={i}>
                  {el.basic === "Y" ? (
                    <div className="product-badges product-badges-position">
                      <span>기본 배송지</span>
                    </div>
                  ) : (
                    ""
                  )}
                  <Addr.AddressContent>
                    <ul className="address-info">
                      <li>
                        <strong>배송지 명: </strong> <span>{el.name}</span>
                      </li>
                      <li>
                        <strong>도로명 주소:</strong>{" "}
                        <span>{el.doro_addr}</span>
                      </li>
                      <li>
                        <strong>지번 주소: </strong> <span>{el.base_addr}</span>
                      </li>
                      <li>
                        <strong>상세 주소: </strong>{" "}
                        <span>{el.detail_addr}</span>
                      </li>
                      <li>
                        <strong>우편번호: </strong> <span>{el.zipcode}</span>
                      </li>
                    </ul>
                    <div className="address-btn">
                      {ownProps.isCheckout ? (
                        <div className="select-btns">
                          <button
                            className="btn-select"
                            type="button"
                            onClick={() => {
                              ownProps.setMemberAddress(el);
                              ownProps.setUserInputs({
                                ...ownProps.userInputs,
                                acode: el.acode,
                                base_addr: el.base_addr,
                                detail_addr: el.detail_addr,
                                doro_addr: el.doro_addr,
                                addressGps: { mapx: el.mapx, mapy: el.mapy },
                                addr_name: el.name,
                                zipcode: el.zipcode,
                              });
                              ownProps.setOpenAddressModal(false);
                            }}
                          >
                            적용
                          </button>
                          <button
                            className="btn-select-basic"
                            onClick={() => {
                              selectDefault(el.acode);
                            }}
                          >
                            기본 배송지로 등록
                          </button>
                        </div>
                      ) : (
                        <>
                          <button
                            className="btn-select-basic"
                            onClick={() => {
                              selectDefault(el.acode);
                            }}
                          >
                            기본 배송지로 등록
                          </button>
                        </>
                      )}

                      <div className="basic-btns">
                        <button
                          className="btn"
                          type="button"
                          onClick={() => handleIsEdit(el)}
                        >
                          수정
                        </button>
                        <button
                          className="btn"
                          type="button"
                          onClick={() => deleteAddress(el.acode)}
                        >
                          삭제
                        </button>
                      </div>
                    </div>
                  </Addr.AddressContent>
                </Addr.AddressBox>
              ))}
            </Addr.ContentWrapper>
          </Addr.Container>
        ) : (
          <NewMyAddress
            isCheckout={ownProps.isCheckout}
            setIsOpen={setIsOpen}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            isOpen={isOpen}
            editAddress={editAddress}
            fetchAddressList={fetchAddressList}
            deleteAddress={deleteAddress}
          />
        ))}
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  loading: state.loading.loading,
  ownProps,
});

const mapDispatchToProps = {
  isLoaded,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAddress);
